import { useContext, useEffect, useState } from "react";
import { CustomFormContext } from "../../CustomForm";
import { prepareContent } from "../../helpers";

interface HiddenStaticValueProps<T extends any> {
  nonForm?: boolean;
  value: T | string | number | boolean | undefined;
  alias: string;
}

const HiddenStaticValue = <T extends any>({
  nonForm = false,
  alias,
  value,
}: HiddenStaticValueProps<T>) => {
  const { setDataDispatch, dataIsSet, tempData } =
    useContext(CustomFormContext);

  const handleSave = () => {
    const data = prepareContent(value, alias, nonForm);
    setDataDispatch({
      type: "UPDATE_CONTENT",
      payload: { ...data },
    });
  };

  useEffect(() => {
    handleSave();
  }, [value, dataIsSet, tempData]);

  return <div />;
};

HiddenStaticValue.fieldType = "HiddenStaticValue";

export default HiddenStaticValue;
